/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from 'theme-ui';
import sizes from './sizes';

export default function VegetarianIcon({ size = 'small', ...rest }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      sx={{
        width: sizes[size],
        height: sizes[size],
        verticalAlign: 'middle',
      }}
      viewBox="0 0 20 20"
      {...rest}
    >
      <path
        fill="currentColor"
        d="M15.989 8.252c-1.061 1.914-2.448 2.583-4.161 2.005-1.011 1.665-1.516 3.781-1.516 6.36l-.009-.001a.464.464 0 01-.92-.082c0-5.249-2.023-8.652-6.093-10.305a.467.467 0 01.348-.864c3.297 1.339 5.377 3.754 6.23 7.206.26-.988.628-1.886 1.102-2.693a.357.357 0 01-.025-.012l.103-.118a9.143 9.143 0 012.076-2.37l.426-.486c-1.44 0-2.298.678-3.088 1.702 0 0-.677-.486-.677-1.865 0-1.23 1.284-2.27 3.35-2.27 2.6 0 3.336-1.056 3.497-1.4.236-.504.96 2.302-.643 5.193z"
      ></path>
    </svg>
  );
}
